import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
// import {
//   unAuth
// } from '@/utils/handle_app'
Vue.use(VueRouter)

const loadPage = (page) => () => import('../views/' + page)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: {
      title: '首页'
    },
    component: loadPage('home')
  },
  {
    path: '/service',
    name: 'Servie',
    meta: {
      title: '客服中心'
    },
    redirect: { name: 'ServieHome' },
    component: loadPage('service'),
    children: [
      {
        path: 'home',
        name: 'ServieHome',
        meta: {
          title: '客服中心'
        },
        component: loadPage('service/home')
      },
      {
        path: 'progress',
        name: 'ServieProgress',
        meta: {
          title: '服务进度'
        },
        redirect: '/service/progress/list',
        component: loadPage('service/progress'),
        children: [
          {
            path: 'list',
            name: 'ServiceProgressList',
            meta: {
              title: '服务进度'
            },
            component: loadPage('service/progress/list')
          },
          {
            path: 'detail/:id',
            name: 'ServiceProgressDetail',
            meta: {
              title: '服务进度'
            },
            component: loadPage('service/progress/detail')
          }
        ]
      },
      {
        path: 'detail/:id',
        name: 'ServiceDetail',
        props: true,
        meta: {
          title: '常见问题'
        },
        component: loadPage('service/detail')
      },
      {
        path: 'complaint',
        name: 'Complaint',
        meta: {
          title: '行程申诉'
        },
        component: loadPage('service/complaint'),
        children: [
          {
            path: 'add/:orderId/:orderType',
            name: 'ComplaintAdd',
            meta: {
              title: '行程申诉'
            },
            component: loadPage('service/complaint/add')
          },
          {
            path: 'record/:id',
            name: 'ComplaintRecord',
            meta: {
              title: '行程申诉'
            },
            component: loadPage('service/complaint/record')
          }
        ]
      }
    ]
  },
  {
    path: '/vehicle',
    name: 'Vehicle',
    meta: {
      title: '选择车型'
    },
    component: loadPage('vehicle')
  },
  {
    path: '/order',
    name: 'Order',
    meta: {
      title: '我的订单'
    },
    redirect: '/order/list',
    component: loadPage('order'),
    children: [
      {
        path: 'list',
        name: 'OrderList',
        meta: {
          title: '订单列表'
        },
        component: loadPage('order/list')
      }
    ]
  },
  {
    path: '/city',
    name: 'City',
    meta: {
      title: '城市选择'
    },
    component: loadPage('city')
  },
  {
    path: '/activity',
    name: 'Activity',
    meta: {
      title: '活动详情'
    },
    component: loadPage('activity')
  },
  {
    path: '/agreement',
    name: 'Agreement',
    meta: {
      title: '协议'
    },
    component: loadPage('agreement'),
    children: [
      {
        path: 'detail/:id',
        name: 'AgreementDetail',
        props: true,
        meta: {
          title: '协议详情'
        },
        component: loadPage('agreement/detail')
      }
    ]
  },
  {
    path: '/promote',
    name: 'Promote',
    component: loadPage('promote/index'),
    children: [
      {
        path: 'driver',
        name: 'PromoteDriver',
        meta: {
          title: '邀请车主'
        },
        component: loadPage('promote/driver/index')
      },
      {
        path: 'driver/register',
        name: 'PromoteDriverRegister',
        meta: {
          title: '活动规则'
        },
        component: loadPage('promote/driver/register')
      },
      {
        path: 'driver/qrcode',
        name: 'PromoteDriverQrcode',
        meta: {
          title: ' 面对面分享'
        },
        component: loadPage('promote/driver/qrcode')
      },
      {
        path: 'driver/record',
        name: 'PromoteDriverRecord',
        meta: {
          title: '邀请记录'
        },
        component: loadPage('promote/driver/record')
      },
      {
        path: 'driver/success',
        name: 'PromoteDriverSuccess',
        meta: {
          title: '领取成功'
        },
        component: loadPage('promote/driver/success')
      },
      {
        path: 'custom',
        name: 'PromoteCustom',
        meta: {
          title: '邀请好友'
        },
        component: loadPage('promote/custom/index')
      },
      {
        path: 'custom/rule',
        name: 'PromoteCustomRule',
        meta: {
          title: '邀请好友'
        },
        component: loadPage('promote/custom/rule')
      },
      {
        path: 'custom/record',
        name: 'PromoteCustomRecord',
        meta: {
          title: '完整邀请记录'
        },
        component: loadPage('promote/custom/record')
      },
      {
        path: 'user',
        name: 'PromoteUser',
        meta: {
          title: '领取优惠券'
        },
        component: loadPage('promote/user/index')
      },
      {
        path: 'user/register',
        name: 'PromoteUserRegister',
        meta: {
          title: '立即领取'
        },
        component: loadPage('promote/user/register')
      },
      {
        path: 'user/qrcode',
        name: 'PromoteUserQrcode',
        meta: {
          title: '面对面分享'
        },
        component: loadPage('promote/user/qrcode')
      }
    ]
  },
  {
    path: '/download',
    name: 'Download',
    meta: {
      title: 'app下载'
    },
    component: loadPage('download')
  },
  {
    path: '/download/guide',
    name: 'DownloadGuide',
    meta: {
      title: 'app引导下载'
    },
    component: loadPage('download/guide')
  },
  {
    path: '/dyyy',
    name: 'Dyyy',
    redirect: '/dyyy/home',
    meta: {
      title: '滇约易游服务中心'
    },
    component: loadPage('dyyy'),
    children: [
      {
        path: 'home',
        name: 'DyyyHome',
        meta: {
          title: '滇约易游服务中心'
        },
        component: loadPage('dyyy/home')
      },
      {
        path: 'safe',
        name: 'DyyySafe',
        redirect: '/dyyy/safe/home',
        meta: {
          title: '安全出行'
        },
        component: loadPage('dyyy/safe'),
        children: [
          {
            path: 'home',
            name: 'DyyySafeHome',
            meta: {
              title: '安全出行'
            },
            component: loadPage('dyyy/safe/home')
          },
          {
            path: 'note',
            name: 'DyyySafeNote',
            meta: {
              title: '出行安全小宝典'
            },
            component: loadPage('dyyy/safe/note')
          },
          {
            path: 'no-inline',
            name: 'DyyySafeNoInline',
            meta: {
              title: '拒绝线下交易'
            },
            component: loadPage('dyyy/safe/no-inline-pay')
          },
          {
            path: 'tool',
            name: 'DyyySafeTool',
            meta: {
              title: '安全工具介绍'
            },
            component: loadPage('dyyy/safe/tool')
          },
          {
            path: 'police',
            name: 'DyyySafePolice',
            meta: {
              title: '110报警'
            },
            component: loadPage('dyyy/safe/police')
          }
        ]
      },
      {
        path: 'no-inline-pay',
        name: 'DyyySafeDetail',
        meta: {
          title: '安全出行'
        },
        component: loadPage('dyyy/safe/no-inline-pay')
      },
      {
        path: 'rule',
        name: 'DyyyRule',
        redirect: '/dyyy/rule/home',
        meta: {
          title: '规则中心'
        },
        component: loadPage('dyyy/rule'),
        children: [
          {
            path: 'home',
            name: 'DyyyRuleHome',
            meta: {
              title: '规则中心'
            },
            component: loadPage('dyyy/rule/home')
          },
          {
            path: 'convention',
            name: 'DyyyRuleConvention',
            meta: {
              title: '顺风车合成公约'
            },
            component: loadPage('dyyy/rule/convention')
          },
          {
            path: 'ceremony',
            name: 'DyyyRuleCeremony',
            meta: {
              title: '顺风车合成礼仪'
            },
            component: loadPage('dyyy/rule/ceremony')
          },
          {
            path: 'user',
            name: 'DyyyRuleuser',
            meta: {
              title: '用户行为管理规则'
            },
            component: loadPage('dyyy/rule/user')
          },
          {
            path: 'invoice',
            name: 'DyyyRuleInvoice',
            meta: {
              keepAlive: true,
              title: '1分钟了解发票'
            },
            component: loadPage('dyyy/rule/invoice')
          },
          {
            path: 'road-fee',
            name: 'DyyyRuleRoadFee',
            meta: {
              title: '高速费用分摊规则'
            },
            component: loadPage('dyyy/rule/road-fee')
          },
          {
            path: 'cancel-trip',
            name: 'DyyyRuleCancelTrip',
            meta: {
              title: '行程取消判责规则详解'
            },
            component: loadPage('dyyy/rule/cancel-trip')
          },
          {
            path: 'score',
            name: 'DyyyRuleScore',
            meta: {
              title: '顺风车信任分规则详解'
            },
            component: loadPage('dyyy/rule/score')
          },
          {
            path: 'cancel-order',
            name: 'DyyyRuleCancelOrder',
            meta: {
              title: '顺风车订单取消率规则'
            },
            component: loadPage('dyyy/rule/cancel-order')
          }
        ]
      },
      {
        path: 'function',
        name: 'DyyyFunction',
        redirect: '/dyyy/function/home',
        meta: {
          title: '功能指南'
        },
        component: loadPage('dyyy/function'),
        children: [
          {
            path: 'home',
            name: 'DyyyFunctionHome',
            meta: {
              title: '功能指南'
            },
            component: loadPage('dyyy/function/home')
          },
          {
            path: 'auto-recieve-order',
            name: 'DyyyFunctionAutoRecieveOrder',
            meta: {
              title: '自动抢单单攻略'
            },
            component: loadPage('dyyy/function/auto-recieve-order')
          },
          {
            path: 'cancel-order',
            name: 'DyyyFunctionCancelOrder',
            meta: {
              title: '取消订单要三思'
            },
            component: loadPage('dyyy/function/cancel-order')
          },
          {
            path: 'carpooling-skill',
            name: 'DyyyFunctionCarpoolingSkill',
            meta: {
              title: '拼车攻略'
            },
            component: loadPage('dyyy/function/carpooling-skill')
          },
          {
            path: 'confirm-get-in',
            name: 'DyyyFunctionConfirmGetIn',
            meta: {
              title: '提醒确认上车'
            },
            component: loadPage('dyyy/function/confirm-get-in')
          },
          {
            path: 'recieve-order-skill',
            name: 'DyyyFunctionRecieveOrderSkill',
            meta: {
              title: '车主接单攻略'
            },
            component: loadPage('dyyy/function/recieve-order-skill')
          }
        ]
      }
    ]
  },
  {
    path: '/driver',
    name: 'Driver',
    meta: {
      title: '司机认证'
    },
    component: loadPage('driver')
  },
  {
    path: '/user',
    name: 'User',
    component: loadPage('user'),
    children: [
      {
        path: 'driver/:id',
        name: 'UserDriver',
        props: true,
        component: loadPage('user/driver')
      },
      {
        path: 'passenger/:id',
        props: true,
        name: 'UserPassenger',
        component: loadPage('user/passenger')
      }
    ]
  },
  {
    path: '/advertisement/:id',
    name: 'Advertisement',
    component: loadPage('advertisement')
  },
  // 开发票
  {
    path: '/invoice',
    name: 'Invoice',
    meta: {
      title: '开发票'
    },
    component: loadPage('invoice/menu')
  },
  // 发票抬头
  {
    path: '/invoice/title',
    name: 'InvoiceTitle',
    meta: {
      title: '发票抬头'
    },
    component: loadPage('invoice/title')
  },
  // 新增发票抬头
  {
    path: '/invoice/addTitle',
    name: 'InvoiceAddTitle',
    meta: {
      title: '新增发票抬头'
    },
    component: loadPage('invoice/addTitle')
  },
  // 编辑发票抬头
  {
    path: '/invoice/updataTitle',
    name: 'InvoiceUpdataTitle',
    meta: {
      title: '编辑发票抬头'
    },
    component: loadPage('invoice/updataTitle')
  },
  // 发票列表
  {
    path: '/invoice/list',
    name: 'InvoiceList',
    meta: {
      title: '开票记录'
    },
    component: loadPage('invoice/list')
  },
  // 发票详情
  {
    path: '/invoice/detail',
    name: 'InvoiceDetail',
    meta: {
      title: '发票详情'
    },
    component: loadPage('invoice/detail')
  },
  // 网约车订单
  {
    path: '/invoice/wycOrderList',
    name: 'InvoiceWycOrderList',
    meta: {
      title: '网约车订单'
    },
    component: loadPage('invoice/wycOrderList')
  },
  // 拼团车订单
  {
    path: '/invoice/ptcOrderList',
    name: 'InvoicePtcOrderList',
    meta: {
      title: '拼团车订单'
    },
    component: loadPage('invoice/ptcOrderList')
  },
  // 网约车开发票
  {
    path: '/invoice/wycMakeInvoice',
    name: 'InvoiceWycMakeInvoice',
    meta: {
      title: '网约车开发票'
    },
    component: loadPage('invoice/wycMakeInvoice')
  },
  // 拼团开发票
  {
    path: '/invoice/ptcMakeInvoice',
    name: 'InvoicePtcMakeInvoice',
    meta: {
      title: '网约车开发票'
    },
    component: loadPage('invoice/ptcMakeInvoice')
  },
  // 开票进度
  {
    path: '/invoice/progress',
    name: 'InvoiceProgress',
    meta: {
      title: '开票进度'
    },
    component: loadPage('invoice/progress')
  },
  {
    path: '/ride/school',
    name: 'RideSchool',
    component: loadPage('ride/school')
  },
  {
    path: '/ride/zhaotong',
    name: 'RideZhaoTong',
    component: loadPage('ride/zhaotong')
  },
  {
    path: '/ride/qujing',
    name: 'RideQujing',
    component: loadPage('ride/qujing')
  },
  {
    path: '/ride/zoo',
    name: 'RideZoo',
    component: loadPage('ride/zoo')
  },
  // 保险
  {
    path: '/insurance/detail',
    name: 'InsuranceDetail',
    component: loadPage('insurance/detail')
  },
  {
    path: '/insurance/order/:id',
    name: 'InsuranceNumber',
    component: loadPage('insurance/order')
  },

  // 领取停车券
  {
    path: '/parking-coupon',
    name: 'ParkingCoupon',
    meta: {
      title: '扫码领券'
    },
    component: loadPage('parking-coupon')
    // 停车收费
  },
  {
    path: '/parking-fee',
    name: 'ParkingFee',
    meta: {
      title: '扫码停车'
    },
    component: loadPage('parking-fee')
  },
  {
    path: '/parking-enter',
    name: 'ParkingEnter',
    meta: {
      title: '停车场入口'
    },
    component: loadPage('parking-enter')
  },
  {
    path: '/barrier-control',
    name: 'BarrierControl',
    meta: {
      title: '道闸控制'
    },
    component: loadPage('barrier-control')
  },

  // 场站开票
  {
    path: '/station-invoice',
    name: 'StationInvoice',
    meta: {
      title: '场站开票'
    },
    component: loadPage('tollgate-invoice')
  },
  // 场站开票成功
  {
    path: '/station-invoice/success',
    name: 'StationInvoiceSuccess',
    meta: {
      title: '提交成功'
    },
    component: loadPage('tollgate-invoice/success')
  },

  // 跳转微信小程序
  {
    path: '/jumpToWeChat',
    name: 'jumpToWeChat',
    meta: {
      title: '滇约出行'
    },
    component: loadPage('jumpToWeChat')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.query.token) {
    store.commit('auth/changeToken', to.query.token)
  }
  if (to.query.userId) {
    store.commit('auth/changeUserId', to.query.userId)
  }
  next()
})

export default router
